module.exports = __webpack_public_path__ + "img/Weapon_203.319a3a34.png";